/* Verkleinerte App-Seite eines Themes (ThemePreview.tsx). Alle Werte aus den --mq-theme-* des gezeigten
   Themes (inline gesetzt), Maße relativ zur Breite (Containereinheiten), damit Kachel und Zeilenbild gleich wirken. */
.mq-theme-preview {
  --mq-theme-preview-field-line: color-mix(in srgb, var(--mq-theme-text) 22%, transparent);
  /* Maße der verkleinerten Seite (cqw = Anteil der Vorschaubreite) */
  --mq-theme-preview-frame-radius: 6px;
  --mq-theme-preview-pill: 999px;
  --mq-theme-preview-rail-gap: 2.2cqw;
  --mq-theme-preview-rail-pad: 4cqw 2.5cqw;
  --mq-theme-preview-brand-margin: 0 0 2cqw 1.5cqw;
  --mq-theme-preview-main-gap: 3.5cqw;
  --mq-theme-preview-main-pad: 4.5cqw 5cqw;
  --mq-theme-preview-title-gap: 1.6cqw;
  --mq-theme-preview-title-leading: 1.1;
  --mq-theme-preview-title-plain: 5.6cqw;
  --mq-theme-preview-card-gap: 2.2cqw;
  --mq-theme-preview-card-pad: 3.6cqw;
  --mq-theme-preview-field-pad: 0 2.4cqw;
  display: flex;
  width: 100%;
  aspect-ratio: 16 / 10;
  container-type: inline-size;
  overflow: hidden;
  border: 1px solid var(--mq-theme-line);
  border-radius: var(--mq-theme-preview-frame-radius);
  background: var(--mq-theme-bg);
  color: var(--mq-theme-text);
  pointer-events: none;
  user-select: none;
}
.mq-theme-preview > * { box-sizing: border-box; }

.mq-theme-preview-rail,
.mq-theme-preview-main,
.mq-theme-preview-card,
.mq-theme-preview-nav,
.mq-theme-preview-field,
.mq-theme-preview-actions,
.mq-theme-preview-btn,
.mq-theme-preview-switch { display: flex; box-sizing: border-box; }
.mq-theme-preview span:empty { display: block; }

/* ---- Leiste ---- */
.mq-theme-preview-rail {
  flex: 0 0 26cqw;
  flex-direction: column;
  gap: var(--mq-theme-preview-rail-gap);
  padding: var(--mq-theme-preview-rail-pad);
  border-right: 1px solid var(--mq-theme-rail-line);
  background: var(--mq-theme-rail-glow), var(--mq-theme-rail);
}
.mq-theme-preview-brand {
  width: 10cqw;
  height: 3cqw;
  margin: var(--mq-theme-preview-brand-margin);
  border-radius: 1cqw;
  background: var(--mq-theme-mark);
}
.mq-theme-preview-nav {
  align-items: center;
  height: 5cqw;
  padding: 0 2cqw;
  border-radius: calc(var(--mq-theme-radius) * 0.5);
}
.mq-theme-preview-nav > span {
  width: 72%;
  height: 1.4cqw;
  border-radius: 1cqw;
  background: var(--mq-theme-rail-text);
  opacity: 0.6;
}
.mq-theme-preview-nav--active { background: var(--mq-theme-rail-active); }
.mq-theme-preview-nav--active > span { background: var(--mq-theme-rail-active-text); opacity: 1; }
.mq-theme-preview[data-typography="display"] .mq-theme-preview-nav--active { border-start-start-radius: 0; border-end-start-radius: 0; box-shadow: inset 0.7cqw 0 0 var(--mq-theme-mark); }

/* ---- Arbeitsfläche ---- */
.mq-theme-preview-main {
  flex: 1;
  flex-direction: column;
  gap: var(--mq-theme-preview-main-gap);
  min-width: 0;
  padding: var(--mq-theme-preview-main-pad);
  background: var(--mq-theme-page-glow), var(--mq-theme-bg);
}
.mq-theme-preview-title {
  display: flex;
  align-items: center;
  gap: var(--mq-theme-preview-title-gap);
  overflow: hidden;
  color: var(--mq-theme-text);
  font-family: var(--mq-theme-title-font);
  font-size: 7cqw;
  font-style: var(--mq-theme-title-style);
  font-weight: var(--mq-theme-title-weight);
  line-height: var(--mq-theme-preview-title-leading);
  letter-spacing: var(--mq-theme-title-tracking);
  text-transform: var(--mq-theme-title-transform);
  white-space: nowrap;
}
.mq-theme-preview-title::before {
  content: "";
  flex: none;
  width: calc(var(--mq-theme-orn-w) * 0.35);
  height: var(--mq-theme-orn-h);
  max-height: 0.9em;
  background: var(--mq-theme-mark);
  transform: skewX(var(--mq-theme-orn-skew));
}
.mq-theme-preview[data-typography="plain"] .mq-theme-preview-title { font-size: var(--mq-theme-preview-title-plain); font-weight: 600; }
.mq-theme-preview[data-typography="plain"] .mq-theme-preview-title::before { display: none; }

/* ---- Karte mit Feld, Schalter und Knöpfen ---- */
.mq-theme-preview-card {
  flex-direction: column;
  gap: var(--mq-theme-preview-card-gap);
  padding: var(--mq-theme-preview-card-pad);
  border: 1px solid var(--mq-theme-line);
  border-radius: calc(var(--mq-theme-radius-lg) * 0.6);
  background: var(--mq-theme-surface);
  box-shadow: var(--mq-theme-card-shadow);
}
.mq-theme-preview-label {
  width: 28%;
  height: 1.3cqw;
  border-radius: 1cqw;
  background: var(--mq-theme-text-2);
  opacity: 0.7;
}
.mq-theme-preview-field {
  align-items: center;
  height: 6.6cqw;
  padding: var(--mq-theme-preview-field-pad);
  border: 1px solid var(--mq-theme-preview-field-line);
  border-radius: calc(var(--mq-theme-radius) * 0.6);
  background: var(--mq-theme-surface);
}
.mq-theme-preview-field > span { width: 46%; height: 1.3cqw; border-radius: 1cqw; background: var(--mq-theme-text-3); opacity: 0.7; }
.mq-theme-preview[data-field="filled"] .mq-theme-preview-field { border-color: transparent; background: color-mix(in srgb, var(--mq-theme-text) 7%, transparent); }
.mq-theme-preview[data-field="underlined"] .mq-theme-preview-field { padding-left: 0; border-width: 0 0 1px; border-radius: 0; background: transparent; }

.mq-theme-preview-actions { align-items: center; gap: 2cqw; margin-top: 1cqw; }
.mq-theme-preview-switch {
  position: relative;
  flex: none;
  width: 9cqw;
  height: 5cqw;
  margin-right: auto;
  border-radius: var(--mq-theme-preview-pill);
  background: var(--mq-theme-primary);
}
.mq-theme-preview-switch > span {
  position: absolute;
  top: 0.6cqw;
  right: 0.6cqw;
  width: 3.8cqw;
  height: 3.8cqw;
  border-radius: 50%;
  background: var(--mq-theme-on-primary);
}
.mq-theme-preview-btn {
  flex: none;
  align-items: center;
  height: 6.6cqw;
  padding: 0 3cqw;
  border: 1px solid var(--mq-theme-preview-field-line);
  border-radius: calc(var(--mq-theme-radius) * 0.6);
  background: var(--mq-theme-surface);
}
.mq-theme-preview-btn > span { width: 7cqw; height: 1.4cqw; border-radius: 1cqw; background: var(--mq-theme-text); }
.mq-theme-preview-btn--primary { border-color: var(--mq-theme-primary); background: var(--mq-theme-primary); }
.mq-theme-preview-btn--primary > span { background: var(--mq-theme-on-primary); }
